import "./App.css";
import logo from "./ten-wickets-logo.png";

import { Bracket, Seed, SeedItem, SeedTeam, SeedTime } from "react-brackets";

const NoName = "-----------";

const Players = [
  "Sam Averis",
  "Shawn Smith",
  "Robert Postill",
  "Kushira Godellwatta",
  "Andy Shaw",
  "Josh Kinal",
  "Karthik Setty",
  "Josh Bispham",
  "Eric Kamara",
  "Shalabh Varma",
  "Asif Mushtaq",
  NoName,
  "Jess Kirwan",
  "Hari Balamani",
  "Ryan Boucher",
  "Jay Bendixen",
];

const Dates = {
  Round1: "October 16 - 23, 2023",
  Round2: "October 30 - November 15, 2023",
  Round3: "November 18 - 24",
  Round4: "November 29, 2023",
};

const rounds2 = [
  {
    title: "Opening Round",
    seeds: [
      {
        id: 4,
        date: Dates.Round1,
        teams: [
          { id: 6, name: Players[6], winner: true },
          { id: 7, name: Players[7] },
        ],
      },
      {
        id: 8,
        date: Dates.Round1,
        teams: [
          { id: 14, name: Players[14], winner: true },
          { id: 15, name: Players[15] },
        ],
      },
      {
        id: 1,
        date: Dates.Round1,
        teams: [
          { id: 0, name: Players[0] },
          { id: 1, name: Players[1], winner: true },
        ],
      },
      {
        id: 6,
        date: Dates.Round1,
        teams: [
          { id: 10, name: Players[10], winner: true },
          { id: 11, name: Players[11] },
        ],
      },

      {
        id: 2,
        date: Dates.Round1,
        teams: [
          { id: 2, name: Players[2] },
          { id: 3, name: Players[3], winner: true },
        ],
      },
      {
        id: 5,
        date: Dates.Round1,
        teams: [
          { id: 8, name: Players[8], winner: true },
          { id: 9, name: Players[9] },
        ],
      },
      {
        id: 3,
        date: Dates.Round1,
        teams: [
          { id: 4, name: Players[4], winner: true },
          { id: 5, name: Players[5] },
        ],
      },
      {
        id: 7,
        date: Dates.Round1,
        teams: [
          { id: 12, name: Players[12], winner: true },
          { id: 13, name: Players[13] },
        ],
      },
    ],
  },
  {
    title: "Quarter Finals",
    seeds: [
      {
        id: 1,
        date: Dates.Round2,
        teams: [
          { id: 3, name: Players[6] },
          { id: 1, name: Players[14], winner: true },
        ],
      },
      {
        id: 1,
        date: Dates.Round2,
        teams: [
          { id: 1, name: Players[1] },
          { id: 3, name: Players[10], winner: true },
        ],
      },
      {
        id: 1,
        date: Dates.Round2,
        teams: [
          { id: 1, name: Players[3], winner: true },
          { id: 3, name: Players[8] },
        ],
      },
      {
        id: 1,
        date: Dates.Round2,
        teams: [
          { id: 1, name: Players[4] },
          { id: 3, name: Players[12], winner: true },
        ],
      },
    ],
  },
  {
    title: "Semi Finals",
    seeds: [
      {
        id: 1,
        date: Dates.Round3,
        teams: [
          { id: 1, name: Players[14], winner: true },
          { id: 3, name: Players[10] },
        ],
      },
      {
        id: 2,
        date: Dates.Round3,
        teams: [
          { id: 1, name: Players[3] },
          { id: 3, name: Players[12], winner: true },
        ],
      },
    ],
  },
  {
    title: "Grand Final",
    seeds: [...new Array(1)].fill({
      id: 1,
      date: Dates.Round4,
      teams: [
        { id: 1, name: Players[14], winner: true },
        { id: 3, name: Players[12] },
      ],
    }),
  },
];

const Empty = () => <SeedTeam>{NoName}</SeedTeam>;
const winner = "#654321";
const loser = "black";

const RenderSeed = ({ breakpoint, seed }) => {
  const teamA = seed.teams[0];
  const teamB = seed.teams[1];

  const teamABackground = teamA.winner ? winner : loser;
  const teamBBackground = teamB.winner ? winner : loser;

  return (
    <Seed mobileBreakpoint={breakpoint} style={{ minWidth: 200 }}>
      <SeedItem style={{ width: "100%" }}>
        <div>
          {teamA.name ? (
            <SeedTeam style={{ backgroundColor: teamABackground }}>{`${teamA.name} ${
              teamA.score ? `(${teamA.score})` : ""
            }`}</SeedTeam>
          ) : (
            <Empty />
          )}
          <div style={{ height: 1, backgroundColor: "#707070" }}></div>
          {teamB.name ? (
            <SeedTeam style={{ backgroundColor: teamBBackground }}>{`${teamB.name} ${
              teamB.score ? `(${teamB.score})` : ""
            }`}</SeedTeam>
          ) : (
            <Empty />
          )}
        </div>
      </SeedItem>
      <SeedTime mobileBreakpoint={breakpoint} style={{ fontSize: 9 }}>
        {seed.date}
      </SeedTime>
    </Seed>
  );
};

const SingleElimination = () => {
  return (
    <Bracket
      mobileBreakpoint={767}
      rounds={rounds2}
      bracketClassName="bracket"
      renderSeedComponent={RenderSeed}
      swipeableProps={{ enableMouseEvents: true, animateHeight: true }}
    />
  );
};

function App() {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src={logo} alt="Ten Wickets Logo" width={300} />
        <h1 style={{ paddingBottom: 8, margin: 0 }}>WORLD CUP 2023</h1>
        <h2 style={{ paddingBottom: 0, margin: 0 }}>Winner: Ryan Boucher</h2>
        <h3 style={{ paddingBottom: 8, margin: 0 }}>Runner-Up: Jess Kirwan</h3>
      </div>
      <SingleElimination />
    </>
  );
}

export default App;
